import { render, staticRenderFns } from "./AssociateBulkRegionForm.vue?vue&type=template&id=65ef3521"
import script from "./AssociateBulkRegionForm.vue?vue&type=script&lang=js"
export * from "./AssociateBulkRegionForm.vue?vue&type=script&lang=js"
import style0 from "./AssociateBulkRegionForm.vue?vue&type=style&index=0&id=65ef3521&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports